import React from "react";

export default function Wallet() {
  return (
    <div>
      <p>Wallet</p>
    </div>
  );
}
